import { to_currency } from '@/utils/currency'

export default function (value, precision) {
    return to_currency('€', precision)(value)
}
